/** Relative Zeitangabe für die Glocke. */

/** Relative Angabe wie „in 3 Tagen" / „vor 2 Std." (grob). */
export function formatReminderRelative(iso: string): string {
  const diffMs = new Date(iso).getTime() - Date.now();
  const past = diffMs < 0;
  const abs = Math.abs(diffMs);
  const min = Math.round(abs / 60000);
  const hour = Math.round(abs / 3600000);
  const day = Math.round(abs / 86400000);
  let core: string;
  if (min < 60) core = `${min} Min.`;
  else if (hour < 48) core = `${hour} Std.`;
  else core = `${day} Tagen`;
  return past ? `vor ${core}` : `in ${core}`;
}
